import React, { useEffect, useState } from "react";
import SalarySlipStyles from "./SalarySlip.styles";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import PrintIcon from "@mui/icons-material/Print";
import SlLogo from "../../assets/icons/sl-Logo.svg";
import RightArrowBig from "../../assets/icons/RightArrowBig.svg";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import CustomDialog from "../../global/components/CustomModal/CustomModal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { store } from "../../utils/store";
import { locationType } from "../../Models/Interface";
import { getUSerSalery, getUserSaleryDetails } from "./SalaryServices";
import customErrorHandler from "../../utils/customErrorHandler";
import { isTruthy, openErrorNotification } from "../../helpers/methods";
import notifiers from "../../global/constants/NotificationConstants";
import { boldFont } from "../../utils/styles";
import { Route } from "react-router-dom";
import { useLocation } from "react-router-dom";

interface CustomProps {
  location: locationType;
}

const options = ["Option 1", "Option 2"];

const breadCrumbList = [
  {
    name: "Leave",
  },
  {
    name: "Slip",
  },
];
const SalarySlip = (props: CustomProps) => {
  const classes = SalarySlipStyles;
  const privileges = store.getState().auth?.privileges || {};
  const [value, setValue] = React.useState<string | null>(options[0]);
  const [inputValue, setInputValue] = React.useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [viewSalaryInfo, setViewSalaryInfo] = useState<any>();
  const [userSalaryDetails, setuserSalaryDetails] = useState<any>("");
  const [getMonth, setGetmonth] = useState();
  const [getYear, setgetyear] = useState();
  const userId = store.getState().auth.userId;
  console.log("userSalaryDetails", userSalaryDetails, props);
  useEffect(() => {
    init();
  }, []);
  const location = useLocation();
  const id_user: any = location.state;
  console.log("eeeeeee", userId, id_user?.fromPage);
  const init = async () => {
    try {
      const response = await getUSerSalery(
        id_user?.fromPage ? id_user?.fromPage : userId
      );
      console.log("responseresponse", response);
      setViewSalaryInfo(response);
      customErrorHandler(response);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleOpenSalery = async (documentId: any) => {
    setIsDialogOpen(true);
    try {
      const response = await getUserSaleryDetails(
        id_user?.fromPage,
        documentId
      );
      console.log("eeeeeee", response);
      customErrorHandler(response);
      setuserSalaryDetails(response);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  function getMonthName(monthNumber: any) {
    switch (monthNumber) {
      case 1:
        return "January";
      case 2:
        return "February";
      case 3:
        return "March";
      case 4:
        return "April";
      case 5:
        return "May";
      case 6:
        return "June";
      case 7:
        return "July";
      case 8:
        return "August";
      case 9:
        return "September";
      case 10:
        return "October";
      case 11:
        return "November";
      case 12:
        return "December";
      default:
        return "Invalid month number";
    }
  }

  const dialogHeaderContent = () => {
    return (
      <>
        <Box></Box>
      </>
    );
  };

  const dialogTitleContent = () => {
    const veiwInfo: any = userSalaryDetails?.data;
    console.log("veiwInfo", veiwInfo);
    const currMonth = getMonthName(veiwInfo?.month);
    return (
      <>
        <Box sx={classes.topSection}>
          <Grid container>
            <Grid item xs={6} display={"flex"} alignItems={"center"}>
              <Typography sx={classes.pageTitle}>Salary Slip</Typography>
            </Grid>

            <Grid item xs={6}>
              <Box sx={classes.headerRight}>
                <Box display={"flex"}>
                  {/* <CustomButton
                    label=""
                    onClick={() => {}}
                    startIcon={<SaveAltIcon />}
                    buttonType="iconBtn"
                  /> */}
                  {/* <CustomButton
                    label=""
                    onClick={() => {}}
                    startIcon={<PrintIcon />}
                    buttonType="iconBtn"
                  /> */}
                  <Box mt={1} ml={2}>
                    <CloseIcon onClick={() => setIsDialogOpen(false)} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={classes.SalarySlipWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.downloadSalarySlipWrapper}>
                <Box sx={classes.dowmlordSlipHeader}>
                  <Box sx={classes.headerLeft}></Box>
                </Box>

                <Box sx={classes.salarySlipContent}>
                  <Box sx={classes.personInfo}>
                    <Box sx={classes.personInfoLeft}>
                      <Typography sx={classes.dateStyle}>
                        {currMonth} {veiwInfo?.year}
                      </Typography>

                      <Typography sx={classes.idStyles}>
                        Employee ID: <span>{veiwInfo?.emp_id}</span>
                      </Typography>
                      <Typography sx={classes.nameStyle}>
                        {veiwInfo?.user_name}
                      </Typography>
                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> Designation: </Box>
                        <span>{veiwInfo?.designation}</span>
                      </Typography>
                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> Department: </Box>
                        <span>{veiwInfo?.department}</span>
                      </Typography>

                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> Date of joining: </Box>
                        <span>{veiwInfo?.joining}</span>
                      </Typography>
                    </Box>
                    <Box sx={classes.personInfoCenter}>
                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> working days: </Box>
                        <span>{veiwInfo?.working_days}</span>
                      </Typography>

                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> Absence: </Box>
                        <span>{veiwInfo?.absence}</span>
                      </Typography>

                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> Leave: </Box>
                        <span>{veiwInfo?.leave}</span>
                      </Typography>
                    </Box>

                    <Box sx={classes.personInfoCenter}>
                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> PF No: </Box>
                        <span>{veiwInfo?.EPF_no}</span>
                      </Typography>

                      <Typography sx={classes.pfStyle}>
                        <Box sx={classes.spanLeft}> ESI No: </Box>
                        <span>{veiwInfo?.ESI_no}</span>
                      </Typography>
                    </Box>

                    <Box sx={classes.personInfoRight}>
                      <Box>
                        <img src={SlLogo} alt="" />
                      </Box>
                      <Typography sx={classes.addStyle}>
                        320, Pride Square,Thanjavur Thanjavur
                      </Typography>
                      <Typography sx={classes.addStyle}>
                        Phone: 9429877966
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={classes.detailsSection}>
                    <Grid container rowSpacing={3} columnSpacing={10}>
                      <Grid item xs={6}>
                        <Box sx={classes.infoBlocks}>
                          <Box>
                            <Typography sx={classes.title}>
                              Salary Payable
                            </Typography>
                          </Box>
                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Basic Salary</Box>
                            <Box sx={classes.itemText}>{veiwInfo?.basic}</Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>HRA</Box>
                            <Box sx={classes.itemText}>{veiwInfo?.HRA}</Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Medical Allowance</Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.medical_allowance}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>
                              Conveyance Allowance
                            </Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.conbeyance_allowance}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Special Allowance</Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.special_allowance}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>
                              PF - Employer Contribution
                            </Box>
                            <Box sx={classes.itemText}>-</Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Others</Box>
                            <Box sx={classes.itemText}>{veiwInfo?.others}</Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText} style={{ ...boldFont }}>
                              Total Earning
                            </Box>
                            <Box sx={classes.itemText} style={{ ...boldFont }}>
                              {veiwInfo?.total_salary}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box sx={classes.infoBlocks}>
                          <Box>
                            <Typography sx={classes.title}>
                              Deduction
                            </Typography>
                          </Box>
                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Tex Deduction</Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.EPF_deduction}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>
                              Employee Contribution
                            </Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.EPF_deduction}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>
                              ESI/ Health Insurance
                            </Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.ESI_deduction}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText}>Loan Deduction </Box>
                            <Box sx={classes.itemText}>
                              {veiwInfo?.loan_deduction}
                            </Box>
                          </Box>

                          <Box sx={classes.listItem}>
                            <Box sx={classes.itemText} style={{ ...boldFont }}>
                              Total Deduction
                            </Box>
                            <Box sx={classes.itemText} style={{ ...boldFont }}>
                              {veiwInfo?.total_deduction}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box sx={classes.salaryInfoBottom}>
                    <Grid container>
                      <Grid item xs={6}></Grid>
                      <Grid item xs={6}>
                        <Box
                          sx={classes.listItem}
                          style={{ borderBottom: "none" }}
                        >
                          <Box
                            sx={classes.itemText}
                            style={{ ...boldFont, fontSize: "16px" }}
                          >
                            Net Payable Salary
                          </Box>
                          <Box
                            sx={classes.itemText}
                            style={{ ...boldFont, fontSize: "16px" }}
                          >
                            {veiwInfo?.net_pay}
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  const getSalarySlipPage = () => {
    return (
      <>
        {privileges &&
        (privileges?.["Salary"].includes("view") ||
          privileges?.["Salary"].includes("full control")) ? (
          <>
            {/* <CustomBreadcrumb breadCrumbList={breadCrumbList} /> */}
            <Box sx={classes.salaryWrapper}>
              <CustomPageHeader
                heading="Salary Slip"
                subInfo="View your salary slip here"
              />
              <Grid container mt={3}>
                <Grid item xs={12}>
                  <Box sx={classes.buttonWrapper}>
                    {viewSalaryInfo?.data.map((items: any) => {
                      const monthName: any = getMonthName(items.month);
                      return (
                        <>
                          <Button
                            sx={classes.button}
                            onClick={() => {
                              handleOpenSalery(items._id);
                            }}
                          >
                            <span>
                              {monthName} {items?.year}
                            </span>
                            <span>
                              <img src={RightArrowBig} alt="" />
                            </span>
                          </Button>
                        </>
                      );
                    })}

                    {/* 
                <Button sx={classes.button} onClick={handleOpenSalery}>
                  <span>January 2020</span>
                  <span>
                    <img src={RightArrowBig} alt="" />
                  </span>
                </Button>

                <Button sx={classes.button} onClick={handleOpenSalery}>
                  <span>January 2020</span>
                  <span>
                    <img src={RightArrowBig} alt="" />
                  </span>
                </Button> */}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {isDialogOpen && (
              <CustomDialog
                fullScreen={true}
                isDialogOpen={isDialogOpen}
                dialogHeaderContent={dialogHeaderContent()}
                dialogTitleContent={dialogTitleContent()}
                handleDialogClose={handleCloseDialog}
              />
            )}
          </>
        ) : (
          ""
        )}
      </>
    );
  };
  return getSalarySlipPage();
};

export default SalarySlip;
